<template>
<div class='bodyer news item'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-wentiquestions1 float-left'></i>FAQ
                </div>
            </div>
        </div>
    </div>

    <article>
        <div class='container'>
            <div class='news'>
                <div class='title'>{{faq.question}}</div>
                <hr>
                <div class='text' v-html='faq.answer'></div>
            </div>
        </div>
    </article>
</div>
</template>

<script type="text/javascript">
import Common from '@/common/Common'
import Storage from '@/common/Storage'
import Request from '@/common/Request'
import Notify from '@/common/Notify'
export default {
    data : function(){
        return {
            'faq' : {}
        }
    },
    created : function(){
        window.scrollTo(0, 0)
        var faq = Storage.get('faq')
        if(!faq){
            Notify.error('参数错误')
            Common.toUrl('/service/faq')
            return false
        }
        console.log('run'+faq)
        this.faq = faq
    }
}
</script>


// WEBPACK FOOTER //
// src/components/service/FaqItem.vue